import React from 'react';

import { HorizontalLine } from './types';

export interface SVGHorizontalLineProps extends HorizontalLine {
    dPath: string | null;
    dashArray?: string;
    text: {
        x: number;
        y: number;
        value: number | string;
        anchor: string;
    };
}
export const SVGHorizontalLine = ({ stroke, dPath, dashArray, yValueVisible, text }: SVGHorizontalLineProps) => (
    <g>
        <path d={dPath || ''} stroke={stroke} strokeDasharray={dashArray} strokeWidth='1' fill='none' />
        {yValueVisible && (
            <text x={text.x} y={text.y} style={{ fontSize: '80%' }} fill={stroke} textAnchor={text.anchor}>
                {text.value}
            </text>
        )}
    </g>
);
